import Link from 'next/link';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MainNavigator = ({ item, pathname }: { item: any; pathname: string }) => {
  return (
    <Link key={item.name} href={item.href} className={`group text-base relative leading-6 ${pathname === item.href ? 'active font-bold' : 'font-medium text-base-white'}`}>
      {item.name}
      <div className={`absolute h-[3px] w-full bg-yellow-600 mt-[17px] transition-opacity duration-300 ease-in-out ${pathname === item.href ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} />
    </Link>
  );
};
